import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M 10 2 L 9 3 L 4 3 L 4 5 L 7 5 L 17 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 5 7 L 5 22 L 19 22 L 19 7 L 5 7 z" })
});
export default SvgTrash;
